import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.PolizaContableDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Fecha de póliza", cell: x => ({ data: kea.toDate(x.FechaPoliza) }) },
    { title: "Tipo", cell: x => ({ data: models.TipoPolizaContable[x.TipoPoliza] }) },
    { title: "Estado", cell: x => ({ data: models.EstadoPolizaContable[x.EstadoPoliza] }) },
    { title: "Concepto", cell: x => ({ data: x.Concepto }) },
    { title: "Factura", cell: x => ({ data: x.SerieFolioFactura }) },
    { title: "Origen", cell: x => ({ data: models.OrigenPolizaContable[x.Origen] }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Cargos", cell: x => ({ data: kea.formatCurrency(x.Cargos) }) },
    { title: "Abonos", cell: x => ({ data: kea.formatCurrency(x.Abonos) }) },
    { title: "Id sistema contabilidad", cell: x => ({ data: x.IdSistemaContabilidad }) },
    { title: "Esta vacía", cell: x => ({ data: x.EstaVacia }) },
    { title: "Id sistema contabilidad de poliza original", cell: x => ({ data: x.IdSistemaContabilidadPolizaOriginal }) },
    { title: "Fecha cancelación ", cell: x => ({ data: kea.toDate(x.FechaCancelacion) }) },
    { title: "Usuario cancelo", cell: x => ({ data: x.NombreUsuarioCancelo }) },
    { title: "Factura Cancelada", cell: x => ({ data: x.SerieFolioFacturaCancelacion }) },
];

export interface BotonesDeps {
    onVer: (x: Entity) => void;
    onReenviar: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps, permisos: models.Rol): Column[] {
    const botones = kea.columnaBotones([
        {
            onClick: deps.onVer,
            tooltip: "Ver",
            iconClass: fa("eye")
        },
        {
            onClick: deps.onReenviar,
            tooltip: "Reenviar poliza",
            disabled: x => !permisos.Contabilidad.VerBotonReenviarPoliza,
            iconClass: fa("refresh")
        }
    ]);
    return [botones, ...columnasFijas];
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/polizas/list/columns.tsx